import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Grid } from '@material-ui/core';

import GeneralInfo from './generalInfo';
import FinancialInfo from './financialInfo';
// import GeneralInformation from './generalInformation';
// import ForeignAssets from './foreignAssets';
// import './styles.css';
// import DifferentSource from './differentSource';
// import TotalIncome from './totalIncome';
// import IncomeTaxPassword from './incomeTax';
// import TravelledOutsideIndia from './travelledOutside';
// import Director from './directorInIndia';
// import AdditionalQuestions from './additionalQuestions';

const useStyles = makeStyles((theme) => ({
    root: {
        margin: '0',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightMedium,
        color: '#4c4c4d',
        fontFamily: 'Rubik',
    },
    checked: {},
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#137cbd',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },
    inlineDisplay: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '10px 0',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    accordContentSummary: {
        background: '#f9f9f9',
    },
}));
// function StyledRadio(props) {
//     const classes = useStyles();

//     return (
//         <Radio
//             className={classes.root}
//             disableRipple
//             color="default"
//             checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
//             icon={<span className={classes.icon} />}
//             {...props}
//         />
//     );
// }
export default function Accordin(props, values) {
    const classes = useStyles();
    // const [selectedValue, setSelectedValue] = React.useState('a');

    const [generalInformation, setGeneralInformationData] = useState([]);

    //console.log('generalInformation', generalInformation);
    const [expanded, setExpanded] = React.useState('');

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    // const handleChange = (event) => {
    //     setSelectedValue(event.target.value);
    // };

    return (
        <div className={classes.root}>
            <div>
                <Grid container spacing={3} className="main-container">
                    <Grid item xs={12} sm={6}>
                        <Typography>CPS Checklist Generator</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography>CPS Checklist Generator</Typography>
                    </Grid>
                </Grid>
            </div>
            <Accordion square expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} id="panel1a-header" className="padding10">
                    <Typography className={classes.heading}>General Information and Permanent file Documents</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.accordContentSummary}>
                    <GeneralInfo />
                </AccordionDetails>
            </Accordion>
            <Accordion square expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header" className="padding10">
                    <Typography className={classes.heading}>Financial Information</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.accordContentSummary}>
                    <FinancialInfo />
                </AccordionDetails>
            </Accordion>
            <Accordion square expanded={expanded === 'panel9'} onChange={handleChange('panel9')}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel7a-content" id="panel7a-header" className="padding10">
                    <Typography className={classes.heading}>Additional Questions</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.accordContentSummary}>{/* <AdditionalQuestions /> */}</AccordionDetails>
            </Accordion>
        </div>
    );
}
